import { useState, FormEvent } from 'react';

export default function CTASection({ submitAddr }: { submitAddr: string }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotInput = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypotInput && honeypotInput.value.trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！');
      return;
    }

    setStatus('loading');
    try {
      const formData = new FormData(form);
      formData.delete('website_alt');
      const res = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '订阅失败';
        setStatus('error');
        setMessage(serverMsg.includes('spam') ? '订阅失败，请稍后重试。' : serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后重试。');
    }
  };

  return (
    <section className="py-14 md:py-18 px-4 md:px-6 bg-primary-500">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
          不错过任何精彩韩漫
        </h2>
        <p className="text-primary-100 text-sm mb-8 max-w-md mx-auto">
          订阅我们的资讯推送，第一时间获取最新韩漫推荐、新作资讯和独家漫评
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form="true"
          className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
        >
          {/* Honeypot */}
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="form-website-alt-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-4 py-3 rounded-lg bg-white text-foreground-900 placeholder:text-foreground-400 text-sm outline-none border-2 border-transparent focus:border-white/30 transition-all"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 bg-foreground-950 hover:bg-foreground-900 text-white font-medium rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer disabled:opacity-60"
          >
            {status === 'loading' ? (
              <span className="flex items-center gap-2">
                <i className="ri-loader-4-line animate-spin"></i>
                提交中
              </span>
            ) : (
              <>
                <i className="ri-mail-send-line mr-1.5"></i>
                订阅资讯
              </>
            )}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-primary-100 text-xs flex items-center justify-center gap-1">
            <i className="ri-check-line"></i>
            {message}
          </p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-primary-100 text-xs flex items-center justify-center gap-1">
            <i className="ri-error-warning-line"></i>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}